// Static Swedish content for BM Juridik (placeholder — to be updated by firm)
import {
    Scale,
    Building2,
    Home,
    Briefcase,
    Gavel,
    Scroll,
    Swords,
    FileSignature,
    Coins,
    HeartHandshake,
    Plane,
    Users,
    Stamp,
} from "lucide-react";

export const FIRM = {
    name: "BM Juridik",
    tagline: "Juristbyrå med kontor över hela Sverige",
    phone: "010-808 56 13",
    phoneTel: "+46108085613",
    email: "kontakt@bmjuridik.se",
    address: "Waterfront Building, Klarabergsviadukten 63, 111 64 Stockholm",
    hours: "Mån — Fre  ·  08.30 — 17.30",
    orgNr: "071221-2042",
    dpo: {
        name: "Daniel Madsen",
        role: "Personuppgiftsansvarig",
        email: "kontakt@bmjuridik.se",
        phone: "0790-52 61 51",
        phoneTel: "+46790526151",
    },
};

export const OFFICES = [
    {
        city: "Stockholm",
        address: "Waterfront Building, Klarabergsviadukten 63",
        postal: "111 64 Stockholm",
    },
    {
        city: "Göteborg",
        address: "Östra Hamngatan 16",
        postal: "441 03 Göteborg",
    },
    {
        city: "Malmö",
        address: "Studio Malmö, Nordenskiöldsgatan 24",
        postal: "211 19 Malmö",
    },
    {
        city: "Uppsala",
        address: "Rådhuset, Vaksalagatan 2",
        postal: "753 20 Uppsala",
    },
    {
        city: "Jönköping",
        address: "Vallgatan 9",
        postal: "553 16 Jönköping",
    },
    {
        city: "Herrljunga",
        address: "Åsbogärde 2",
        postal: "524 93 Herrljunga",
    },
];

export const AREAS = [
    {
        id: "affarsjuridik",
        icon: Briefcase,
        title: "Affärsjuridik",
        short:
            "Rådgivning vid bolagsbildning, avtal, M&A och kommersiella tvister.",
        long:
            "Från uppstart till börsintroduktion — vi företräder svenska och internationella klienter i hela kedjan av affärsjuridiska frågor. Vi hjälper styrelser, grundare och investerare att fatta trygga beslut.",
        bullets: [
            "Aktieägaravtal & bolagsstyrning",
            "Företagsöverlåtelser (M&A)",
            "Kommersiella kontrakt",
            "Tvistelösning i domstol & skiljenämnd",
        ],
    },
    {
        id: "fastighetsratt",
        icon: Building2,
        title: "Fastighetsrätt",
        short:
            "Transaktioner, hyresrätt, entreprenadjuridik och fastighetstvister.",
        long:
            "Vi är en förtrolig partner för fastighetsägare, utvecklare och byggherrar. Vi hanterar allt från förvärv och due diligence till komplexa entreprenadfrågor enligt AB 04 och ABT 06.",
        bullets: [
            "Fastighetstransaktioner & DD",
            "Entreprenadjuridik (AB 04 / ABT 06)",
            "Kommersiell hyresrätt",
            "Plan- & byggärenden",
        ],
    },
    {
        id: "familjeratt",
        icon: Home,
        title: "Familjerätt",
        short:
            "Äktenskapsskillnad, bodelning, vårdnad och arvsrätt med varsam hand.",
        long:
            "När livet förändras behövs både juridisk precision och mänsklig omtanke. Vi biträder i hela spektrumet av familjerätt, alltid med diskretion och barnens bästa i fokus. **Inledande rådgivning vid vårdnadstvister är kostnadsfri.**",
        bullets: [
            "Bodelning & äktenskapsförord",
            "Vårdnad, boende och umgänge — kostnadsfri inledande rådgivning",
            "Arvsrätt & testamenten",
            "Framtidsfullmakter",
        ],
    },
    {
        id: "arbetsratt",
        icon: Scale,
        title: "Arbetsrätt",
        short:
            "Strategisk rådgivning till både arbetsgivare och arbetstagare.",
        long:
            "Vi stöttar företag i personalrelaterade frågor — från anställningsavtal och omorganisationer till tvister i Arbetsdomstolen. För arbetstagare företräder vi i diskriminerings- och uppsägningsmål.",
        bullets: [
            "Anställningsavtal & policys",
            "Uppsägning & avsked",
            "Kollektivavtal & MBL-förhandlingar",
            "Arbetsdomstolen",
        ],
    },
    {
        id: "brottmal",
        icon: Gavel,
        title: "Brottmål",
        short:
            "Privat försvarare och målsägandebiträde — engagerat försvar i alla instanser.",
        long:
            "Som erfarna brottmålsjurister företräder vi misstänkta och målsäganden i såväl mindre som uppmärksammade mål. Vi finns tillgängliga dygnet runt vid frihetsberövande.",
        bullets: [
            "Privat försvarare",
            "Målsägandebiträde",
            "Ekobrott & bedrägerier",
            "Jour vid frihetsberövande (24/7)",
        ],
    },
    {
        id: "arvsratt",
        icon: Scroll,
        title: "Arvsrätt",
        short:
            "Testamente, bouppteckning, arvsskifte och framtidsfullmakt — med varsam hand.",
        long:
            "Arvsrätten är ofta vägledande i livets viktigaste stunder. Vi upprättar tydliga testamenten, leder bouppteckningar och arvsskiften, samt hjälper dig förbereda framtidsfullmakter och gåvobrev som tryggar både dig och dina närstående.",
        bullets: [
            "Testamente",
            "Bouppteckning & arvsskifte",
            "Framtidsfullmakt",
            "Gåvobrev & skuldebrev",
        ],
    },
    {
        id: "socialratt",
        icon: HeartHandshake,
        title: "Socialrätt",
        short:
            "Offentligt biträde vid LVU, LVM och LPT — vi står på din sida.",
        long:
            "När samhället fattar ingripande beslut om enskilda finns vi som förordnade offentliga biträden. Vi företräder barn, unga och vuxna i mål enligt LVU, LVM och LPT, och arbetar lika mycket med det juridiska som med det mänskliga i varje ärende.",
        bullets: [
            "LVU (vård av unga)",
            "LVM (missbruksvård)",
            "LPT (psykiatrisk tvångsvård)",
            "Överklaganden till förvaltningsrätt",
        ],
    },
    {
        id: "migrationsratt",
        icon: Plane,
        title: "Migrationsrätt",
        short:
            "Uppehållstillstånd, asyl, medborgarskap och arbetskraftsinvandring.",
        long:
            "Vi företräder klienter i hela migrationsprocessen — från första ansökan till prövning i Migrationsöverdomstolen. Vårt arbete sträcker sig från familjeåterförening till komplexa asylärenden och talerätt för förvarstagna.",
        bullets: [
            "Asyl & skyddsbehov",
            "Uppehålls- och arbetstillstånd",
            "Familjeåterförening",
            "Medborgarskap & förvarsärenden",
        ],
    },
    {
        id: "skatteratt",
        icon: Coins,
        title: "Skatterätt",
        short:
            "Skatterådgivning och processföring mot Skatteverket.",
        long:
            "Vi hjälper privatpersoner och företag att navigera ett av Sveriges mest komplexa rättsområden. Proaktiv skatteplanering, generationsskiften och processer i förvaltningsdomstol — vi ser till att du betalar rätt skatt, varken mer eller mindre.",
        bullets: [
            "Skatteplanering & generationsskiften",
            "Inkomstdeklarationer vid tvister",
            "Omprövning & överklagande",
            "Mål i förvaltningsdomstol",
        ],
    },
    {
        id: "tvistelosning",
        icon: Swords,
        title: "Tvistelösning",
        short:
            "Förhandling, medling och process i domstol eller skiljenämnd.",
        long:
            "När en tvist uppstår avgör tidiga val ofta hela utgången. Vi arbetar strategiskt från första kontakt — med siktet inställt på snabb, affärsmässig lösning när det är möjligt och stark processföring när det krävs.",
        bullets: [
            "Förhandling & medling",
            "Processföring i tingsrätt & hovrätt",
            "Skiljeförfarande",
            "Kronofogden & betalningsförelägganden",
        ],
    },
    {
        id: "avtalsratt",
        icon: FileSignature,
        title: "Avtalsrätt",
        short:
            "Upprättande, granskning och förhandling av avtal.",
        long:
            "Ett välskrivet avtal sparar både tid, pengar och relationer. Vi upprättar och granskar allt från enkla uppdragsavtal till komplexa kommersiella kontrakt, alltid med fokus på att balansera risk och affär utan att tappa läsbarhet.",
        bullets: [
            "Kommersiella avtal",
            "Konsult- & anställningsavtal",
            "Sekretess- & samarbetsavtal",
            "Avtalsgranskning (due diligence)",
        ],
    },
    {
        id: "foreningsjuridik",
        icon: Users,
        title: "Föreningsjuridik",
        short:
            "Stöd till bostadsrättsföreningar, ideella och ekonomiska föreningar.",
        long:
            "Styrelser har ett stort ansvar — och ibland mycket begränsad juridisk kunskap. Vi bistår föreningar med allt från stadgeändringar och stämmofrågor till hantering av störande medlemmar och tvister med entreprenörer.",
        bullets: [
            "Stadgar & stämmobeslut",
            "Bostadsrättsjuridik",
            "Styrelseansvar",
            "Medlems- & entreprenadtvister",
        ],
    },
    {
        id: "notarius-publicus",
        icon: Stamp,
        title: "Notarius Publicus",
        short:
            "Bestyrkande, vidimering och apostille — av förordnad notarius publicus i Vårgårda, Herrljunga, Vara och Alingsås kommun (verksam över hela riket).",
        long:
            "Daniel Madsen är av Länsstyrelsen förordnad notarius publicus för Vårgårda, Herrljunga, Vara och Alingsås kommun, med rätt att utföra förrättningar i hela landet. I rollen utfärdar vi intyg med officiell status — bland annat apostille, vidimering av kopior, bevittning av underskrifter och bekräftelse av behörigheter. Vi tar emot bokningar vid samtliga sex kontor samt vid besök.",
        bullets: [
            "Apostille (Haag-konventionen)",
            "Bevittning & bekräftelse av underskrift",
            "Vidimering av kopior",
            "Intyg om behörighet & översättningar",
        ],
    },
];

export const TEAM = [
    {
        name: "Bianca Madsen",
        role: "Ägare  ·  Juristassistent",
        email: "bianca@bmjuridik.se",
        bio: "Ägare och drivande kraft på BM Juridik. Bianca ansvarar för byråns dagliga drift, koordinerar klientuppdrag över samtliga kontor och arbetar med fokus på ekonomiskt inriktad familjerätt. Klienterna uppskattar särskilt hennes tydliga kommunikation och förmåga att förklara juridiska processer i varje steg.",
        focus: ["Administration", "Klientkontakter", "Ekonomisk familjerätt"],
    },
    {
        name: "Daniel Madsen",
        role: "Jur. kand.  ·  Jurist",
        phone: "0790-52 61 51",
        phoneTel: "+46790526151",
        email: "daniel@bmjuridik.se",
        photo: "/team/daniel-madsen.jpg",
        bio: "Jur. kand. från Handelshögskolan vid Göteborgs universitet (2012) och verksam som jurist sedan dess. Daniel har byggt upp en gedigen erfarenhet från flera rättsområden, med särskilt stark bakgrund inom vårdnadstvister och civilrättslig tvistelösning. Han företräder såväl privatpersoner som företag i alla instanser — från första förhandling till process i domstol. Av Länsstyrelsen förordnad Notarius Publicus för Vårgårda, Herrljunga, Vara och Alingsås kommun, med rätt att verka över hela riket.",
        notarius: true,
        focus: [
            "Affärsjuridik",
            "Fastighetsrätt",
            "Familjerätt",
            "Arbetsrätt",
            "Brottmål",
            "Arvsrätt",
            "Socialrätt",
            "Migrationsrätt",
            "Skatterätt",
            "Tvistelösning",
            "Avtalsrätt",
            "Föreningsjuridik",
            "Notarius Publicus",
        ],
    },
];

export const POSTS = [
    {
        slug: "vad-ar-en-framtidsfullmakt",
        date: "3 mars 2026",
        category: "Familjerätt  ·  Guide",
        title: "Vad är en framtidsfullmakt? — Komplett guide 2026",
        excerpt:
            "En framtidsfullmakt är ett av de mest underskattade juridiska dokumenten i Sverige. Här går vi igenom vad det är, när det gäller, hur det skiljer sig från god man, vilka formkrav som måste uppfyllas — och vad som händer om du inte har någon.",
        body: `En framtidsfullmakt är ett juridiskt dokument där du i förväg utser en eller flera personer som ska få fatta beslut åt dig den dag du själv inte längre kan. Det är ett alternativ till god man och förvaltare — men på dina villkor, inte tingsrättens.

Trots att lagen om framtidsfullmakter trädde i kraft redan 2017 saknar fortfarande en stor majoritet av svenskarna ett sådant dokument. För de familjer som hamnar i situationen utan framtidsfullmakt kan konsekvenserna bli allvarliga: räkningar som inte betalas, fastigheter som inte kan säljas, och en lång byråkratisk process där tingsrätten utser en god man som ofta är en helt främmande person.

Den här guiden går igenom allt du behöver veta — vad en framtidsfullmakt egentligen är, när den träder i kraft, vilka formkrav som måste vara uppfyllda för att den ska vara giltig, och varför det är värt att upprätta en även om du är ung och frisk.

Vad gäller en framtidsfullmakt — kortfattat
En framtidsfullmakt aktiveras först när du inte längre kan sköta dina egna angelägenheter, exempelvis vid demens, stroke eller annan allvarlig sjukdom. Tills dess har den ingen verkan. Du behåller alltså full kontroll över dina pengar, ditt boende och dina beslut så länge du har förmåga att fatta dem själv.

När fullmaktshavaren bedömer att du inte längre kan handla för dig själv träder fullmakten i kraft. Det krävs ingen myndighetsprövning eller domstolsbeslut för det — fullmaktshavaren agerar direkt utifrån dokumentets innehåll.

Vad kan en framtidsfullmakt omfatta?
Du bestämmer själv vilka områden fullmakten ska täcka. De vanligaste är:

Ekonomiska angelägenheter
- Betala räkningar och löpande utgifter
- Hantera bankkonton, lån och kreditkort
- Sälja eller köpa fastighet, bostadsrätt eller bil
- Förvalta värdepapper och pensionssparande
- Företräda dig i kontakter med Försäkringskassan, Skatteverket och Pensionsmyndigheten

Personliga angelägenheter
- Välja boendeform (eget hem, äldreboende, demensboende)
- Företräda dig i kontakt med vården
- Ansöka om hemtjänst, ledsagning eller andra stödinsatser
- Företräda dig i kontakt med kommun och socialtjänst

Det är också vanligt att kombinera ekonomiska och personliga befogenheter. Du kan begränsa eller utvidga vad du vill — det viktiga är att fullmakten är tydligt formulerad så att tredje part (banker, mäklare, vårdgivare) faktiskt godkänner den.

Skillnad mellan framtidsfullmakt, god man och förvaltare
Det här är den punkt där flest blir förvirrade — så låt oss reda ut det.

God man och förvaltare utses av tingsrätten när du redan är beslutsoförmögen och inte har någon framtidsfullmakt på plats. Det är en formell process där en utomstående person, ofta okänd för dig och din familj, får i uppdrag att ta över dina ekonomiska eller personliga beslut. Processen kan ta månader, kostar pengar (godmansarvode betalas vanligen av huvudmannen själv) och omfattar löpande tillsyn av överförmyndaren.

En framtidsfullmakt undviker hela den processen. Du har redan i ett tidigt skede pekat ut en person du litar på — oftast en make/maka, vuxet barn eller god vän — och dokumentet träder i kraft direkt utan domstolsbeslut. Ingen utomstående blandas in, ingen löpande tillsyn behövs, och dina anhöriga slipper en byråkratisk hängmatta i ett redan tungt skede.

Det finns ändå en viktig kontrollmekanism: överförmyndaren kan på begäran granska hur fullmakten används om någon misstänker missbruk.

Formkrav för att en framtidsfullmakt ska vara giltig
Lagen ställer fyra huvudkrav. Saknas något av dem är dokumentet ogiltigt — och det är just här de flesta gör-det-själv-mallar fallerar.

1. Du måste vara minst 18 år och förstå vad du gör. Om du redan är dement kan du alltså inte upprätta en framtidsfullmakt — det är då för sent.

2. Det ska tydligt framgå att det är en framtidsfullmakt. Ordet "framtidsfullmakt" ska finnas med och det ska klart anges att den träder i kraft först när du inte längre kan sköta dina angelägenheter.

3. Två vittnen krävs. Vittnena måste vara närvarande samtidigt när du undertecknar och själva skriva under på samma gång. Vittnena får inte vara fullmaktshavaren själv, eller dennes maka/make/sambo, syskon eller barn. Vittnena ska vara minst 15 år och ha förstått innebörden av sin underskrift.

4. Skriftlig form. Muntliga framtidsfullmakter finns inte. Dokumentet måste vara på papper och underskrivet i original.

Vanliga misstag vi stöter på
Vid BM Juridik granskar vi regelbundet framtidsfullmakter som familjer själva har upprättat med hjälp av nätmallar. De vanligaste felen:

Otydlig formulering kring fastigheter. Om fullmakten ska kunna användas för att sälja en fastighet eller bostadsrätt måste det framgå uttryckligen. Bankerna och Lantmäteriet är mycket strikta här.

Vittnen som är jäviga. Sambos vuxna barn räknas inte som "släkting" i vardaglig mening men kan ändå diskvalificeras beroende på relationer.

Inga substitut. Om den person du utsett själv blir oförmögen, avlider eller tackar nej — vad händer då? En väl skriven framtidsfullmakt har alltid en eller två andrahandsfullmaktshavare.

Att fullmakten inte hittas. Det här är överraskande vanligt. Dokumentet ligger i en låda, och när det väl behövs minns ingen var. Vi rekommenderar att originalet förvaras hos en betrodd person eller i bankfack, och att kopia delas med fullmaktshavaren samt de närmast anhöriga.

Vad händer om du inte har någon framtidsfullmakt?
Säg att du i 70-årsåldern drabbas av en stroke och inte längre kan kommunicera tydligt. Banken fryser dina konton så snart de får kännedom om saken. Din partner kan inte sälja sommarstugan ni planerat byta ut. Din pension fortsätter komma in på ett konto ingen kan röra. Räkningar förfaller.

Familjen får då ansöka om god man hos överförmyndaren. Beroende på kommun tar processen mellan 1 och 6 månader. Tingsrätten utser ofta en helt utomstående person, vanligen en advokat eller arbetslös jurist, som får full kontroll över din ekonomi. Personen kostar i snitt 12 000–25 000 kr per år, vilket dras direkt från dina tillgångar. Och dina anhöriga får inget formellt inflytande.

En framtidsfullmakt undviker det här. Den kostar några tusenlappar att upprätta och förvaras sedan i åratal innan — om någonsin — den behöver användas.

När bör du upprätta en?
Många tror att framtidsfullmakter är ett dokument för pensionärer. Det är fel.

Olyckor händer. Stroke och allvarliga sjukdomar kan drabba i alla åldrar. Vid BM Juridik har vi i flera ärenden mött anhöriga till personer i 40- och 50-årsåldern som plötsligt fastnat i en god man-process som hade kunnat undvikas med ett dokument upprättat tio år tidigare.

Vår rekommendation: alla vuxna med tillgångar, fastighet eller minderåriga barn bör ha en framtidsfullmakt på plats. Det är en del av ett komplett juridiskt skydd, tillsammans med testamente och eventuellt äktenskapsförord.

Hur upprättar du en framtidsfullmakt?
Du har tre alternativ:

1. Skriva själv. Det är gratis men risken för fel är hög. Om dokumentet visar sig ogiltigt när det väl ska användas är det för sent att göra om.

2. Använda en mall. Bättre än att skriva från grunden, men mallar är generella och passar inte alla situationer. Vid komplexa familjeförhållanden, näringsverksamhet eller utlandstillgångar räcker en mall sällan till.

3. Anlita jurist. Vi på BM Juridik upprättar individuellt anpassade framtidsfullmakter till fast pris (1 500 kr inkl. moms). Vi går igenom din situation, förklarar formkraven, ser till att vittnesreglerna följs och förvarar gärna en kopia i vårt arkiv för framtida bruk.

Vill du upprätta en framtidsfullmakt?
Boka ett kort intagssamtal — kostnadsfritt — så går vi igenom din situation och avgör om en framtidsfullmakt räcker eller om även testamente och äktenskapsförord bör ses över. Vi har kontor i Stockholm, Göteborg, Malmö, Uppsala, Jönköping och Herrljunga, och hela ärendet kan hanteras digitalt om du föredrar det.

Disclaimer: Den här artikeln är allmän rådgivning och ersätter inte individuell juridisk rådgivning. Reglerna kan ändras och varje familjesituation är unik.`,
    },
    {
        slug: "notarius-publicus-i-sverige-vad-kan-de-intyga",
        date: "20 februari 2026",
        category: "Notarius Publicus  ·  Guide",
        title: "Notarius Publicus i Sverige — vad kan de intyga?",
        excerpt:
            "En notarius publicus utför officiell myndighetsutövning som behövs när dokument ska användas utomlands eller när krav på officiell bestyrkelse ställs. Här förklarar vi exakt vad en notarius publicus får göra, vad det kostar och när du faktiskt behöver hjälpen.",
        body: `Notarius publicus är en officiell roll utsedd av Länsstyrelsen som har till uppgift att intyga sanningar — främst för att svenska handlingar ska kunna användas utomlands, eller för att utländska handlingar ska få verkan i Sverige.

Trots att rollen är central vid arv över gränser, internationella affärer och studier utomlands råder det stor förvirring om vad en notarius publicus egentligen kan göra. Många blandar ihop rollen med "notary public" i USA — som är något helt annat. Andra tror att vilken jurist eller advokat som helst kan utföra notariella förrättningar. Det stämmer inte heller.

Den här artikeln går igenom vad en svensk notarius publicus faktiskt har behörighet att göra, vad varje tjänst kostar, och de vanligaste situationerna då du behöver hjälpen.

Vad är en notarius publicus i juridisk mening?
Begreppet kommer från latin och betyder "offentlig skrivare". I Sverige regleras rollen i lag (1981:1363) om notarius publicus. Det är en roll som tilldelas individuellt av Länsstyrelsen efter ansökan, och som vanligtvis ges till advokater eller jurister som uppfyller kraven på lämplighet, juridisk utbildning och erfarenhet.

En notarius publicus är inte en domstol och fattar inga rättsliga avgöranden. Vad rollen gör är att fastställa fakta — och göra det på ett sätt som myndigheter, banker och domstolar i andra länder kan lita på. När du får ett dokument bestyrkt av en svensk notarius publicus är det en officiell handling som har bevisvärde långt utanför Sveriges gränser.

Vad kan en notarius publicus intyga?
Behörigheten är förhållandevis bred. Här följer de vanligaste tjänsterna med konkreta exempel på när de behövs.

Bevittning av namnteckning
Den vanligaste tjänsten. En notarius publicus intygar att en specifik person har undertecknat en specifik handling, och att personen har styrkt sin identitet med pass eller nationellt id-kort. Detta är ofta krav när du undertecknar en fullmakt, ett gåvobrev eller ett kontrakt som ska användas utomlands.

Pris hos BM Juridik: 500 kr (450 kr vid online-beställning).

Vidimering av kopia
Notarien intygar att en kopia är en exakt avskrift av originalhandlingen. Vanligt vid:
- Examensbevis som ska visas upp för utländska universitet
- Födelse- och vigselbevis vid uppehållstillstånd utomlands
- Bolagshandlingar i internationella avtal

Pris: 500 kr.

Apostille
Apostille är en specifik typ av officiell stämpel som krävs enligt Haagkonventionen från 1961. Den intygar att en svensk myndighetsstämpel eller handling är äkta, så att den kan användas direkt i något av de drygt 125 anslutna länderna. Utan apostille måste handlingen ofta legaliseras via flera myndigheter — en process som tar veckor.

Apostille är vanligast vid:
- Internationella arvskiften (när någon avlidit i Sverige men hade tillgångar utomlands, eller tvärtom)
- Adoption från utlandet
- Erkännande av svenska giftermål eller skilsmässor i annat land
- Företagsregistreringar i annat EU-land

Pris: 650 kr per dokument (600 kr vid online-beställning).

Intyg om namnunderskrift
Ett mer formellt intyg där notarien bekräftar att underskriften på en handling är personligt gjord av en viss namngiven person. Skillnaden mot enkel bevittning är att detta dokument vanligen utfärdas som separat intyg på engelska och svenska.

Pris: 500 kr.

Firmateckningsintyg
Ett notariellt intyg om vem som är behörig att teckna ett aktiebolags eller annan organisations firma. Baseras på registreringsbevis från Bolagsverket och används framför allt vid:
- Internationella bankaffärer där företaget öppnar konto utomlands
- Avtal med utländska parter där motparten kräver bevis på behörighet
- Köp eller försäljning av tillgångar utomlands i bolagets namn

Pris: 850 kr.

Intyg av pass eller id-handling
Notariellt intyg om identitet baserat på pass eller nationellt id-kort. Vanligt vid:
- Visumansökningar till länder med strängare krav (Saudiarabien, Förenade Arabemiraten, Kina)
- Köp av fastighet utomlands där säljaren kräver formell identifiering
- Vissa internationella domstolsprocesser där partsidentitet måste styrkas

Pris: 500 kr.

Närvaro- och levnadsintyg
Notariellt intyg om att en specifik person är i livet och närvarande på datumet. Krävs framför allt vid:
- Utländska pensionsutbetalningar (många länder kräver levnadsintyg en eller flera gånger per år)
- Försäkringsersättningar från utlandet
- Vissa typer av fastighetstransaktioner

Pris: 850 kr.

Bestyrkande av examenshandlingar
Officiellt bestyrkande av examensbevis och betyg från svenska universitet och högskolor — för dig som ska studera, forska eller arbeta utomlands. Kombineras nästan alltid med apostille om mottagarlandet ingår i Haagkonventionen.

Pris: 500 kr.

Affidavit och deklarationer under ed
Mer formella beedigade utlåtanden där en person under straffansvar förklarar något skriftligt. Främst aktuellt i internationella domstolsprocesser, vid utländska skatteärenden eller vid internationella tvister.

Pris: från 1 500 kr.

Företag och större ärenden
För komplexa ärenden kan en notarius publicus även:
- Bestyrka bolagshandlingar (styrelseprotokoll, bolagsstämmoprotokoll, ändringar i bolagsordning) — från 1 250 kr
- Hantera due diligence-paket för företagsöverlåtelser — enligt offert
- Certifiera större dokumentpaket vid internationella affärer — enligt offert
- Handlägga utländska handlingar och komplexa ärenden — från 1 500 kr

Vad kan en notarius publicus inte göra?
Det är minst lika viktigt att veta var gränsen går.

En notarius publicus kan inte:
- Ge juridisk rådgivning om innehållet i ett dokument (det är inte en notaries roll)
- Besluta om eller upphäva ett kontrakt
- Företräda dig i domstol
- Garantera att ett dokument får verkan i ett specifikt utländskt land — det avgörs alltid av mottagarlandet
- Översätta handlingar (men kan certifiera att en översättning är riktig)

Om du behöver juridisk rådgivning kring innehållet i en handling — exempelvis ett kontrakt, ett testamente eller en fullmakt — är det en jurist eller advokat du ska tala med, inte en notarius publicus. Vid BM Juridik har vi båda rollerna inom samma byrå, vilket gör processen smidigare för dig.

Hur går ett besök hos notarius publicus till?
Ett vanligt notarius publicus-besök är förvånansvärt snabbt. Så här ser standardflödet ut:

1. Boka tid (online eller via telefon).
2. Kom till kontoret med originalhandlingen och giltig id-handling (pass eller nationellt id-kort, körkort räcker inte).
3. Notarien går igenom handlingen, kontrollerar identitet och utför själva förrättningen — bevittning, vidimering eller annan tjänst.
4. Du får en stämplad och underskriven handling, ofta tillsammans med ett intyg på engelska om internationell användning.

Hela besöket tar normalt 10–20 minuter. För apostille kan det ibland krävas en arbetsdag extra om handlingen först måste till en annan myndighet.

Online-beställning ger 50 kr rabatt
För att underlätta processen kan du beställa flertalet av våra notarius publicus-tjänster online och betala i förväg via kort, Klarna eller Swish. Du sparar 50 kr per tjänst och får ett bokningsmejl direkt med kontoradress, tider och vilka handlingar du ska medta.

Internationella ärenden — så undviker du fallgropar
Det vanligaste misstaget vi möter är att personer betalar för en notariell tjänst utan att veta vad mottagarlandet faktiskt kräver. Olika länder har helt olika krav:

- Inom EU och Haag-länder räcker normalt apostille.
- Saudiarabien, Förenade Arabemiraten och vissa andra länder kräver legalisering via flera nivåer (notarius publicus → utrikesdepartementet → mottagarlandets ambassad).
- USA godtar normalt apostille men har specifika regler för vissa delstater.
- Kina kräver alltid extra legalisering.

Vid komplexa internationella ärenden hjälper vi gärna till att kartlägga exakt vilka steg som krävs, så du inte behöver göra om proceduren.

Var hittar du en notarius publicus?
Notarius publicus finns på alla större orter i Sverige. Vid BM Juridik finns notarius publicus tillgänglig vid våra kontor i Stockholm, Göteborg, Malmö, Uppsala, Jönköping och Herrljunga.

Behöver du en notariell handling? Beställ online till fast pris med 50 kr rabatt, eller boka tid via vår kontaktsida — vi återkommer samma arbetsdag.

Disclaimer: Den här artikeln är allmän information och utgör inte juridisk rådgivning. Vid specifika ärenden, särskilt internationella, rekommenderar vi alltid kontakt med jurist eller notarius publicus för individuell bedömning.`,
    },
    {
        slug: "vardnadstvist-ensam-vardnad-varmland-feb-2026",
        date: "25 februari 2026",
        category: "Familjerätt  ·  Avgörande",
        title:
            "Klient tillerkänd ensam vårdnad — Värmlands tingsrätt avslår motpartens yrkande om umgänge",
        excerpt:
            "Värmlands tingsrätt meddelade den 25 februari 2026 dom i ett vårdnadsmål där BM Juridik företrädde den ena föräldern genom rättshjälp. Tingsrätten gick helt på vår klients linje — ensam vårdnad beviljades och motpartens yrkande om reglerat umgänge ogillades.",
        body: `Den 25 februari 2026 meddelade Värmlands tingsrätt dom i ett vårdnadsmål där Daniel Madsen, jurist vid BM Juridik, var förordnat rättshjälpsbiträde för den ena föräldern. Tingsrätten biföll samtliga av vår klients yrkanden.

Frågorna i målet
Målet rörde dels yrkande om ensam vårdnad om ett minderårigt barn, dels motpartens genkäromål om reglerat umgänge en gång i månaden. Bakgrunden var en mångårig konflikt och i princip obefintlig samarbetsförmåga mellan föräldrarna.

Tingsrättens bedömning
Tingsrätten utgick — som alltid i vårdnadsmål — från barnets bästa. Rätten fäste särskild vikt vid att samarbetet mellan föräldrarna var så pass dåligt att gemensam vårdnad i praktiken omöjliggjort viktiga beslut rörande barnet, bland annat kring id-handlingar, pass och hälso- och sjukvård. Barnet hade ett dokumenterat behov av struktur och trygga rutiner och hade, med hänsyn till ålder och mognad, själv uttryckt en tydlig vilja att bo hos vår klient. Vår klient hade burit huvudansvaret för skola, sjukvård och myndighetskontakter, och den fortlöpande konflikten bedömdes vara negativ för barnets psykiska hälsa.

Sammantaget fann tingsrätten att ensam vårdnad hos vår klient var det alternativ som bäst tillgodosåg barnets bästa.

Umgänget
När det gällde motpartens yrkande om reglerat umgänge konstaterade rätten att umgänget i praktiken skulle bli beroende av barnets egen vilja. Mot bakgrund av barnets ålder, den mycket begränsade kontakten de senaste åren samt barnets uttalade inställning gick yrkandet inte att genomföra på det sätt motparten begärt. Umgängesyrkandet ogillades därför i sin helhet.

Vad domen visar
Utgången bekräftar en linje som vi på BM Juridik arbetar utifrån i varje vårdnadstvist: domstolen ser till barnets faktiska vardag, inte till hur föräldrarna formulerar sig i skrift. Dokumentation av samarbetssvårigheter, praktisk föräldraroll och barnets egen vilja väger alltid tyngst.

Har du frågor om vårdnad, boende eller umgänge är du välkommen att kontakta oss för ett kostnadsfritt inledande samtal. Rättshjälp kan beviljas — vi utreder vad som gäller i just ditt fall.

Domen har anonymiserats. Inga klient- eller barnuppgifter återges.`,
    },
    {
        slug: "nya-regler-bolagsstyrning-2026",
        date: "12 december 2025",
        category: "Affärsjuridik",
        title: "Nya regler för bolagsstyrning 2026 — så förbereder du styrelsen",
        excerpt:
            "Från årsskiftet skärps kraven på svensk bolagsstyrning. Vi går igenom vad som gäller och hur styrelser praktiskt kan anpassa sitt arbete.",
        body: `Från och med den 1 januari 2026 införs flera förändringar som påverkar hur svenska aktiebolag styrs. För styrelser i såväl noterade som privata bolag innebär detta att rutiner för beslutsdokumentation, intressekonflikter och hållbarhetsrapportering behöver ses över.

I praktiken rekommenderar vi att varje styrelse under första kvartalet 2026 genomför en genomlysning av arbetsordning, instruktion för vd och bolagets policys. Där processerna är för muntliga eller ostrukturerade kan det snabbt uppstå risker — särskilt i samband med förvärv eller investeringsrundor där due diligence blir omfattande.

BM Juridik biträder regelbundet styrelser i detta arbete. Kontakta oss för en inledande dialog.`,
    },
    {
        slug: "fastighetsagare-energikrav",
        date: "28 november 2025",
        category: "Fastighetsrätt",
        title: "Fastighetsägare och nya energikrav — vad kontraktet bör reglera",
        excerpt:
            "När kraven på energiprestanda skärps måste både ägare och hyresgäster tänka om kring ansvarsfördelning.",
        body: `EU-direktivet om byggnaders energiprestanda kräver att ägare till kommersiella fastigheter vidtar åtgärder med tydliga deadlines. Frågan är vem som ska bära kostnaden — fastighetsägaren eller hyresgästen?

Standardavtalen ger inte alltid tydliga svar, och tolkningen riskerar att bli en källa till framtida tvister. Vi rekommenderar att nya hyresavtal innehåller en uttrycklig klausul om energiåtgärder, och att äldre avtal ses över vid nästa omförhandling.`,
    },
    {
        slug: "familjeratt-framtidsfullmakt-kort",
        date: "6 november 2025",
        category: "Familjerätt",
        title: "Framtidsfullmakt — så undviker du de vanligaste misstagen",
        excerpt:
            "Vi möter regelbundet familjer där en framtidsfullmakt visat sig ogiltig när den behövs. Här är en kort sammanfattning av de vanligaste fallgroparna.",
        body: `Vi har skrivit en mer omfattande guide till framtidsfullmakter — se artikeln "Vad är en framtidsfullmakt? — Komplett guide 2026" för en fördjupning.

I korthet är de tre vanligaste misstagen vi möter:

1. Vittnen som är jäviga (make/maka, sambo, barn till fullmaktshavaren får inte vittna).
2. Otydlig formulering kring fastigheter — banker och Lantmäteriet är strikta här.
3. Inga substituter — om utsedd fullmaktshavare själv blir oförmögen, vad händer då?

Vi hjälper gärna till med en individuellt anpassad framtidsfullmakt — kontakta oss för ett kort intagssamtal.`,
    },
];

export const TESTIMONIALS = [
    {
        quote:
            "Daniel är tillmötesgående och har mycket kunskap. Jag upplever honom som väldigt duktig på sitt arbete. Jag upplever honom som engagerad i mina ärenden.",
        author: "Martin B.",
    },
    {
        quote:
            "Ett bra och informativt samtal, även om svaren inte var de jag hoppats på. Fick genast ett förtroende och nu vet jag vart jag vänder mig nästa gång livet strular till det!",
        author: "Tullie L.",
    },
    {
        quote: "Snabbt och proffsigt bemötande och hjälp med juridiskt dokument.",
        author: "Carina A.",
    },
    {
        quote:
            "Fick personlig och professionell hjälp av Daniel att skriva ett testamente. Han tog sig tid att besvara alla mina frågor i lugn och ro. Uppskattar också möjligheten att kunna välja var mötet skulle ske.",
        author: "Ann-Charlotte T.",
    },
    {
        quote:
            "Jag fick ett fint bemötande och snabba svar på mina frågor. Daniel gav bra svar och det märks att han vet vad han pratar om och kan vad som gäller lagmässigt. Tusen tack!",
        author: "Sofie J.",
    },
    {
        quote:
            "Daniel har varit ett oerhört stöd i min vårdnadstvist och är inte så \u201Cadvokatig\u201D utan han tar ner juridiken till en nivå som jag begriper.",
        author: "Ingemar H.",
    },
    {
        quote:
            "I min vårdnadstvist kändes det som ingen lyssnade förutom Daniel — tack för din hjälp.",
        author: "Tua A.",
    },
];

export const STATS = [
    { number: "12", label: "rättsområden" },
    { number: "6", label: "kontor i Sverige" },
    { number: "24h", label: "återkoppling garanterat" },
    { number: "4.9", label: "klientomdöme (av 5)" },
];
